import { throwErrorWithId } from '@pypestream/utils';

export const getAssetsUrl = (url?: string): string | undefined => {
  try {
    if (!url) {
      throwErrorWithId('No URL provided');
      return;
    }

    const parsedUrl = new URL(url);

    const parts = parsedUrl.pathname.split('/');
    parts.pop();

    const cleanPath = parts.filter(Boolean).join('/');

    parsedUrl.pathname = `/${cleanPath}/`;

    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return undefined;
  }
};
